/* Global imports. */
import React from "react";

const SectionBreak = () => <hr className="w-full mt-8 mb-8 border-t border-t-[#E0E0E0]" />;

export default SectionBreak;
